import { GT_Project } from '../types/projects'
import { GT_Remaining_Work } from '../types/remaining-work'
import { GT_Date } from '../types/dates'
import { Week_Filter } from '@app/filter/week-filter'
import { Whiteboard_List } from '@app/post-lists/whiteboard-list'
import { Assembly_List } from '@app/post-lists/assembly-list'
import { Week_Status_List } from '@app/post-lists/week-status-list'
import { Invoice_List } from '@app/post-lists/invoice-list'
import { GT_Invoice } from '../types/invoices'
import { Time_List } from '@app/post-lists/times-list'
import { GT_Time } from '../types/times'

export interface Ctx {
    name: string
    projects: GT_Project[]
    remaining_work: GT_Remaining_Work[]
    dates: GT_Date[]
    invoices: GT_Invoice[]
    times: GT_Time[]
    lists: {
        assembly?: Assembly_List
        whiteboard?: Whiteboard_List
        week_status?: Week_Status_List
    }
    filters: {
        week_filter?: Week_Filter
    }
}

export class Context implements Ctx {
    name: string
    projects: GT_Project[]
    remaining_work: GT_Remaining_Work[]
    dates: GT_Date[]
    invoices: GT_Invoice[]
    times: GT_Time[]
    lists: {
        assembly?: Assembly_List
        whiteboard?: Whiteboard_List
        week_status?: Week_Status_List
        invoices?: Invoice_List
        times?: Time_List
    }
    filters: {
        week_filter?: Week_Filter
    }

    constructor( name: string ) {
        console.log( `erstelle ctx für ${name}` )

        this.name = name

        this.projects = gt_results.projects ?? []
        this.remaining_work = gt_results.remaining_work ?? []
        this.dates = gt_results.dates ?? []
        this.invoices = gt_results.invoices ?? []
        this.times = gt_results.times ?? []

        this.lists = {}
        this.filters = {}

        switch ( name ) {
            case 'whiteboard-list':
                this.set_whiteboard_context()
                break
            case 'assembly-list':
                this.set_assembly_context()
                break
            case 'week-status-list':
                this.set_week_context()
                break
            case 'invoice-list':
                this.set_invoice_context()
                break
            case 'time-list':
                this.set_time_context()
                break
            default:
        }

        console.log( `ctx für ${this.name} erfolgreich erstellt` )
    }

    set_whiteboard_context(): void {
       this.lists.whiteboard = new Whiteboard_List( this )
    }

    set_assembly_context(): void {
        this.lists.assembly = new Assembly_List( this )
    }

    set_week_context(): void {
        this.lists.week_status = new Week_Status_List( this )
    }

    set_invoice_context(): void {
        this.lists.invoices = new Invoice_List( this )
    }

    set_time_context(): void {
        this.lists.times = new Time_List( this )
    }
}
